export default {
  heading: {
    widgetName: "Hotels",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Promotions | BigPay x Superapp Promo`,
      eventLabelCardClick: `BigPay | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `BigPay | headline | {{headline}}`,
      eventLabelView: `BigPay x Superapp Promotions`,
    },
  },


  data: [
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_Home-Widget_REWARDS_MS.jpg",
      title: "Masa Untuk Dapatkan Poin",
      subtitle: "2x  poin airasia dengan setiap transaksi Tertakluk T&S.",
      cta: "Dapatkan Sekarang",
      url: "https://www.airasia.com/rewards/ms/my",
      subtitleExpandCtaText:"",
      promotionTnC:""
    },
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_Home-Widget_FLIGHTS_MS.jpg",
      title: "Masa untuk Bercuti",
      subtitle: "DISKAUN 5% untuk semua penerbangan, Kod Promosi: [BIGPAY5]. Tertakluk T&S.",
      cta: "Tempah Sekarang",
      url: "https://www.airasia.com/flight/ms/my?promocode=BIGPAY5",
      subtitleExpandCtaText:"",
      promotionTnC:""
    },
    
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_Home-Widget_HOTELS_MS.jpg",
      title: "Masa untuk Berehat",
      subtitle: "DISKAUN RM50 untuk setiap hotel, Kod Promosi: [BIGPAY5]. Dengan perbelanjaan minimum RM350. Tertakluk T&S.",
      cta: "Tempah Sekarang",
      url: "https://www.airasia.com/hotels/ms/my",
      subtitleExpandCtaText:"",
      promotionTnC:""
    },
    {
      primaryLabel: '',
      image: "https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_Home-Widget_RIDE_MS.jpg",
      title: "Masa untuk Mengembara",
      subtitle: "Dapatkan baucar RM10 Ride*. *Selepas melengkapkan 5 perjalanan. Penebusan bulanan adalah terhad. Tertakluk T&S.",
      cta: "Tempah Sekarang",
      url: "https://www.airasia.com/ride/ ",
      subtitleExpandCtaText:"",
      promotionTnC:""
    }
  ],
}
